import Manifesto from "@/components/site/Manifesto";
import { Seo } from "@/components/Seo";

export default function ManifestoPage() {
  return (
    <main data-testid="page-manifesto" className="pt-20">
      <Seo
        title="Manifesto — Delta DL Enterprise, LLC"
        description="The manifesto of Delta DL Enterprise, LLC — the values and convictions behind every class, book, and artwork by Dr. Dennis Louden."
        path="/manifesto"
      />
      <Manifesto />
    </main>
  );
}
